import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import {
	IDishAssignmentContext,
	DishAssignmentContext,
} from '../../../../../dishAssignmentState/dishAssignmentContext';
import Button from 'components/Button/Button';
import breadcrumbs from 'images/breadcrumbs.svg';
import style from './ResetBtn.module.scss';

const ResetBtn: React.FC = () => {
	const { resetSelectedControls, IDSelectedCustomer, isUnassignedDishes, searchString } =
		useContext<IDishAssignmentContext>(DishAssignmentContext);

	const disabled = !IDSelectedCustomer && !isUnassignedDishes && !searchString;

	return (
		<Button
			className={style.resetBtn}
			theme="secondary"
			onClick={resetSelectedControls}
			disabled={disabled}
			icon={
				<svg className={style.icon}>
					<use xlinkHref={`${breadcrumbs}#resetIcon`} />
				</svg>
			}
			data-test="ResetBtn">
			<Text translationNameSpace="listing" translationKey="resetButton" asFragment={true} />
		</Button>
	);
};

export default ResetBtn;
